export const AUTHORIZATION_LOADING = "AUTHORIZATION_LOADING";
export const AUTHORIZATION_SUCCESS = "AUTHORIZATION_SUCCESS";
export const AUTHORIZATION_FAILED = "AUTHORIZATION_FAILED";


export const TOKEN_LOADING = "TOKEN_LOADING";
export const TOKEN_SUCCESS = "TOKEN_SUCCESS";
export const TOKEN_FAILED = "TOKEN_FAILED";

export const ARN_CONFIG_LOADING = "ARN_CONFIG_LOADING";
export const ARN_CONFIG_SUCCESS = "ARN_CONFIG_SUCCESS";
export const ARN_CONFIG_FAILED = "ARN_CONFIG_FAILED";

export const ARN_AUTHORIZATION_LOADING = "ARN_AUTHORIZATION_LOADING";
export const ARN_AUTHORIZATION_SUCCESS = "ARN_AUTHORIZATION_SUCCESS";
export const ARN_AUTHORIZATION_FAILED = "ARN_AUTHORIZATION_FAILED";